<template>
  <b-modal id="createRelationUserDataModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmrelationuserdata.createRelationUserDataHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="relation">
      <b-col>
        <Create :relation="relation"></Create>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Create from '../Create.vue'
export default {
  name: 'EXCMRelationUserDataCreateModal',
  components: {
    Create
  },
  computed: {
    show () {
      return this.$store.state.modals.excmrelationuserdata.create.show
    },
    relationObject () {
      return this.$store.state.modals.excmrelationuserdata.create.relation
    },
    close () {
      return this.$store.state.modals.excmrelationuserdata.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'relationObject': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      relation: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.relationObject) {
        this.relation = Object.assign({}, this.relationObject)
        this.$store.state.modals.excmrelationuserdata.create.show = 0
        this.$store.state.modals.excmrelationuserdata.create.relation = null
        this.$bvModal.show('createRelationUserDataModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmrelationuserdata.create.close = 0
      }
      this.$bvModal.hide('createRelationUserDataModal')
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
